<template>
    <div>
        <radio-button-dropdown
            :radio-button-list="radioButtonList "
            :visible-items="5"
            :list-heading="'App.RadioButtonListHeader.SelectTopic'"
            :default-radio-button="selectedRadioButtonData.labelText"
            :sub-topic="subTopic"
            :select-by-url="true"
            class="subject-radios"
            @selected-radio-button="handleSelectedSubjectRadioButton"
            @selected-drop-down="handleSelectedDropDown"
            @radio-buttons-changed="handleRadioButtonsChanged"
        />
        <area-lists
            v-show="showLocationDropdowns"
            list-heading="App.RadioButtonListHeader.ValitseAlue"
            @selected-radio-button="handleAreaSelectionRadioButton"
            @selected-list-value="handleAreaSelectionListValue"
        >
            >
        </area-lists>
        <div
            v-show="showSearchAddress"
            class="search-components"
        >
            <search-address />
            <locate-me class="locate-me-wrapper" />
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Watch, Prop } from "vue-facing-decorator"
    import SearchAddress from "@/components/SearchAddress.vue"
    import LocateMeLink from "@/components/LocateMeLink.vue"
    import ApiService from "@/services/ApiService"
    import SearchResultModel from "@/models/searchresultmodel"
    import RadioButtonListWithDropdown from "@/components/RadioButtonListWithDropdown.vue"
    import RadioButtonModel from "@/models/radiobuttonmodel"
    import DropDownListModel from "@/models/dropdownlistmodel"
    import MunicipalitiesAndProvinces from "@/components/MunicipalitiesAndProvinces.vue"
    import LatLngPoint from "@/models/latlngpoint"
    import MobileSpeedTypesModel from "@/models/mobilespeedtypesmodel"
    import { LMap } from "vue3-leaflet"
    import { store } from '@/store/store'

    @Component({
        components: {
            "locate-me": LocateMeLink,
            "search-address": SearchAddress,
            "radio-button-dropdown": RadioButtonListWithDropdown,
            "area-lists": MunicipalitiesAndProvinces,
            LMap
        }
    })
    export default class LaajakaistaJaPuhelin extends Vue {
        @Prop({ type: String }) subTopic!: string

        apiService: ApiService = new ApiService(store.getters.baseHref)

        // DataPublishServices rajapintakutsun etuosa
        apiCallBasePart: string = "v1/Viestinta/LaajakaistaJaPuhelin/"

        // coordinaatit
        coordX: string = ""
        coordY: string = ""

        oikeusPuhelinJaLaajakaistaLiittymaanSijainti: boolean = false
        pageName: string = "laajakaistajapuhelin"

        mobileSpeedTypesDropDownValues: Array<DropDownListModel> = []
        mobileSpeedTypes: MobileSpeedTypesModel[] = []
        geomanMap: any = null

        radioButtonList: Array<RadioButtonModel> = this.selectSubjectRadiobuttonSelectListData
        // Valittu radiobutton tietoineen
        selectedRadioButtonData: RadioButtonModel = this.defaultRadioButton
        selectedRadioDropDownMobiili: string = ""
        // Oletusarvo.
        selectedRadioDropDownOikeus: string = "5Mlaajakaista"

        // ruutukoko
        get displayType(): string {
            return store.getters.displayType
        }

        get showSearchAddress(): boolean {
            // jos kunta/maakunta komponettinäkyvillä niin osoitehakua ei näytetä
            return !this.showLocationDropdowns
        }

        get showLocationDropdowns(): boolean {
            return this.selectedRadioButtonData.radioValue !== "Laajakaistahankkeet"
                && this.selectedRadioButtonData.radioValue !== "OikeusPuhelinJaLaajakaistaLiittymaanPalvelutyypinMukaan"
                && this.selectedRadioButtonData.groupName !== "Infokartat"
                && this.selectedRadioButtonData.radioValue !== "KiinteanVerkonSaatavuusRuuduilla"
        }

        get leftSlotHeaderLaajakaistaJaPuhelin(): string | undefined {
            return this.$t("App.LeftSlot.Header.LaajakaistaJaPuhelin")
        }

        // Radiobutton valintalistaan syötettävä data
        get selectSubjectRadiobuttonSelectListData(): Array<RadioButtonModel> {
            const list: RadioButtonModel[] = [
                new RadioButtonModel("App.LaajakaistaJaPuhelin.RadioList.KiinteänLaajakaistaverkonNopeus", "KiinteanLaajakaistanSaatavuus", "KiinteanLaajakaistanSaatavuus"),
                new RadioButtonModel("App.LaajakaistaJaPuhelin.RadioList.MobiiliverkonKattavuus", "MobiiliverkonKattavuus", "MobiiliverkonKattavuus", this.mobileSpeedTypesDropDownValues, ""),
                new RadioButtonModel("App.RightSlotHeaderTemplate.KiinteanVerkonSaatavuusRuuduillaHeader", "KiinteanVerkonSaatavuusRuuduilla", "KiinteanVerkonSaatavuusRuuduilla"),
                new RadioButtonModel("App.LaajakaistaJaPuhelin.RadioList.OikeusPuhelinJaLaajakaistaLiittymaan", "OikeusPuhelinJaLaajakaistaLiittymaanPalvelutyypinMukaan", "OikeusPuhelinJaLaajakaistaLiittymaan",
                                     [
                                         // Päivitä this.selectedRadioDropDownOikeus sen mukaan mikä tässä on ensimmäisenä.
                                         new DropDownListModel("App.OikeusPuhelinJaLaajakaistaLiittymaan.DropDownList.5Mlaajakaista", "5Mlaajakaista", false),
                                         new DropDownListModel("App.OikeusPuhelinJaLaajakaistaLiittymaan.DropDownList.Puhelinpalvelu", "Puhelinpalvelu", false),
                                         new DropDownListModel("App.OikeusPuhelinJaLaajakaistaLiittymaan.DropDownList.Tekstiviestipalvelu", "Tekstiviestipalvelu", false),
                                         new DropDownListModel("App.OikeusPuhelinJaLaajakaistaLiittymaan.DropDownList.Laajakaista", "512k512klaajakaista", false),
                                         new DropDownListModel("App.OikeusPuhelinJaLaajakaistaLiittymaan.DropDownList.All", "All", false)
                                     ], ""),
                new RadioButtonModel("App.LaajakaistaJaPuhelin.RadioList.Laajakaistahankkeet", "Laajakaistahankkeet")
            ]

            // haetaan infokartat
            const radioButtonListValues = store.getters.infokarttaRadioValues ?? new RadioButtonModel("", "")
            if (radioButtonListValues) {
                radioButtonListValues.forEach(element => {
                    if (this.activeLang.toString() === "fi") {
                        list.push(new RadioButtonModel(element.nimifi, element.tunniste, "Infokartat"))
                    }
                    else if (this.activeLang.toString() === "sv") {
                        list.push(new RadioButtonModel(element.nimisv, element.tunniste, "Infokartat"))
                    }
                    else {
                        list.push(new RadioButtonModel(element.nimien, element.tunniste, "Infokartat"))
                    }
                })
            }

            return list ?? [new RadioButtonModel("", "")]
        }

        async getMobileSpeedTypesDB(): Promise<void> {
            const json = await this.apiService.dynamicApiCall(this.apiCallBasePart + "MobiiliverkonNopeusluokat")
            this.mobileSpeedTypes = json
            this.mobileSpeedTypesDropDownValues = this.parseMobileSpeedTypesDropDownValues()
            if (this.selectedRadioDropDownMobiili === "") this.selectedRadioDropDownMobiili = this.mobileSpeedTypesDropDownValues[0].identifier
        }

        parseMobileSpeedTypesDropDownValues(): Array<DropDownListModel> {
            const dropdowns: DropDownListModel[] = []
            this.mobileSpeedTypes.forEach(element => {
                // HUOM TP: jos tulee käyttöön uusia tekniikka + nopeus pareja, niin niille pitää lisätä uudet käännökset manuaaliin. 17.01.2023 manuaalissa (2023_02) LTE 30M ja 100M ja 5G 100M + 300M
                // tyyliin EXEC InsertLanguageTerm @AppName='TIKUKartat', @ResourceKey='App.LaajakaistaJaPuhelin.Mobiili.DropdownList.5G.Download1000M', @Value='5G 1000Mbit/s';
                const nopeusteksti = element.nopeusteksti?.replace(/\./g, "")
                const tekniikkaNopeusTeksti = this.$t("App.LaajakaistaJaPuhelin.Mobiili.DropdownList." + element.nopeustekstitekniikka + "." + nopeusteksti) ?? "App.LaajakaistaJaPuhelin.Mobiili.DropdownList." + element.nopeustekstitekniikka + "." + nopeusteksti
                dropdowns.push(new DropDownListModel(tekniikkaNopeusTeksti, element.nopeustekstitekniikka + ";" + element.nopeusteksti, false))
            })
            return dropdowns
        }

        // Kun tämä dynaaminen komponentti aktvioidaan leftslotilla, triggeröityy tämä metodi
        async activated(): Promise<void> {
            this.oikeusPuhelinJaLaajakaistaLiittymaanSijainti = false

            // tyhjännetään kartan edellinen lokaatiot
            store.dispatch("setStopLocate")
            store.dispatch("setCurrentPage", this.pageName)

            store.dispatch("setLoading", { name: this.pageName, value: true })
            await this.getInfokartat()
            await this.getMobileSpeedTypesDB()
            this.radioButtonList = this.selectSubjectRadiobuttonSelectListData

            this.selectedRadioButtonData = this.defaultRadioButton
            store.dispatch("setSelectedSubjectRadioButton", this.selectedRadioButtonData)

            // Asetetaan oikean slotin sisältö
            store.dispatch("setRightSlot", this.selectedRadioButtonData.groupName ?? this.selectedRadioButtonData.radioValue)

            // Tehdään apikutsu, jolla haetaan kartan data
            await this.setDataToLoad(this.selectedRadioButtonData)

            store.dispatch("setLoading", { name: this.pageName, value: false })
        }

        async getInfokartat() {
            const infokartatData = store.getters.laajakaistaJaPuhelinInfokarttaRadioValues
            store.dispatch("setInfokarttaRadioValues", infokartatData)
        }

        deactivated() {
            store.dispatch("setCurrentPage", "")
            store.dispatch("setSubTopic", null)
            this.radioButtonList = []
            store.dispatch("setInfokarttaRadioValues", [])
            store.dispatch("setSelectedDropDownResourceKey", "")
            store.dispatch("setSelectedAreaRadioButton", "")
            store.dispatch("setSelectedMunicipality", "")
            store.dispatch("setSelectedProvince", "")
        }

        handleAreaSelectionRadioButton(item: RadioButtonModel) {
            store.dispatch("setSelectedAreaRadioButton", String(item))
            this.updateData(store.getters.rightSlot, null, null, null)
        }

        handleAreaSelectionListValue(item: string) {
            // Valittu kunta tai maakunta dropdownista
            if (store.getters.selectedAreaRadioButton === "kunta") {
                store.dispatch("setSelectedMunicipality", item)
            }
            else if (store.getters.selectedAreaRadioButton === "maakunta") {
                store.dispatch("setSelectedProvince", item)
            }
        }

        async handleSelectedSubjectRadioButton(item: RadioButtonModel) {
            this.selectedRadioButtonData = item
            store.dispatch("setSelectedSubjectRadioButton", item)

            // Jos käydään jossain toisessa näkymässä niin nollataan sijainnin mukaan haun tila.
            if (this.selectedRadioButtonData.radioValue !== "OikeusPuhelinJaLaajakaistaLiittymaanPalvelutyypinMukaan") {
                this.oikeusPuhelinJaLaajakaistaLiittymaanSijainti = false
            }

            // Tehdään apikutsu, jolla haetaan kartan data
            await this.setDataToLoad(this.selectedRadioButtonData)
        }

        async handleSelectedDropDown(item: string) {
            if (this.selectedRadioButtonData.radioValue === "OikeusPuhelinJaLaajakaistaLiittymaanPalvelutyypinMukaan") {
                this.oikeusPuhelinJaLaajakaistaLiittymaanSijainti = false
                this.selectedRadioDropDownOikeus = item
            }
            else if (this.selectedRadioButtonData.radioValue === "MobiiliverkonKattavuus") {
                this.selectedRadioDropDownMobiili = item
            }
            await this.setDataToLoad(this.selectedRadioButtonData)
        }

        handleRadioButtonsChanged(list: Array<RadioButtonModel>) {
            // Päivitä defaultina valittu radio button
            this.selectedRadioButtonData = list[0]

            if (this.selectedRadioButtonData.radioValue === "OikeusPuhelinJaLaajakaistaLiittymaanPalvelutyypinMukaan") {
                this.selectedRadioButtonData.selectedDropDownListValue = this.selectedRadioDropDownOikeus
            }
            else if (this.selectedRadioButtonData.radioValue === "MobiiliverkonKattavuus") {
                this.selectedRadioButtonData.selectedDropDownListValue = this.selectedRadioDropDownMobiili
            }
        }

        get currentPage(): string {
            return store.getters.currentPage
        }

        get activeLang(): SearchResultModel {
            return store.getters.activeLang
        }

        @Watch("activeLang")
        async onActiveLang(): Promise<void> {
            // kielivalinta muuttunut. nyt pitäisi lataa data uudestaan ja käyttäjän tekemä mahdollinen valinta....
            if (this.currentPage !== this.pageName) {
                return
            }
            await this.getMobileSpeedTypesDB()
            let radioValue = store.getters.rightSlot

            if (this.selectedRadioButtonData.groupName === "OikeusPuhelinJaLaajakaistaLiittymaan") {
                this.selectedRadioButtonData.selectedDropDownListValue = this.selectedRadioDropDownOikeus
                radioValue = this.selectedRadioButtonData.radioValue
            }
            else if (this.selectedRadioButtonData.radioValue === "MobiiliverkonKattavuus") {
                this.selectedRadioButtonData.selectedDropDownListValue = this.selectedRadioDropDownMobiili
            }
            this.updateData(radioValue, null, null, this.selectedRadioButtonData)
        }

        get defaultRadioButton(): RadioButtonModel {
            // Jos sivulle tullaan subTopic routen kautta, niin asetetaan default radiobutton value routen mukaisesti
            if (this.subTopic) {
                for (let i = 0; i < this.radioButtonList.length; i++) {
                    if (this.radioButtonList[i].radioValue === this.subTopic) {
                        return this.radioButtonList[i]
                    }
                }
            }

            return this.radioButtonList[0]
        }

        getFilters(selectedRadio: RadioButtonModel): URLSearchParams {
            const filter = new URLSearchParams()
            this.selectedRadioButtonData = selectedRadio
            switch (selectedRadio.radioValue) {
                case "OikeusPuhelinJaLaajakaistaLiittymaanPalvelutyypinMukaan":
                    if (!this.oikeusPuhelinJaLaajakaistaLiittymaanSijainti) {
                        if (this.selectedRadioDropDownOikeus != null) {
                            let type = this.selectedRadioDropDownOikeus
                            if (type === "All") {
                                type = ""
                            }
                            filter.append("type", type)
                        }
                        return filter
                    }
                    else {
                        // ei tyyppi, kaikki näytetään
                        if (this.coordX !== "") {
                            filter.append("koordinaattiX", this.coordX)
                        }
                        if (this.coordY !== "") {
                            filter.append("koordinaattiY", this.coordY)
                        }
                        return filter
                    }
                case "MobiiliverkonKattavuus":
                    if (this.selectedRadioDropDownMobiili != null) {
                        // valittu nopeus on mallia tekniikka;nopeus
                        const speedfilters = this.selectedRadioDropDownMobiili.split(";")
                        filter.append("tekniikka", speedfilters[0])
                        filter.append("nopeus", speedfilters[1])
                    }
                    return filter
                default:
                    return filter
            }
        }

        // Osoite haku
        get searchAddressSelected(): SearchResultModel | null {
            return store.getters.searchAddressSelected
        }

        @Watch("searchAddressSelected")
        async onSearchAddressSelected(): Promise<void> {
            if (this.searchAddressSelected) {
                if (this.selectedRadioButtonData.groupName === "OikeusPuhelinJaLaajakaistaLiittymaan") {
                    this.coordX = this.searchAddressSelected.coordinates.lat.toString()
                    this.coordY = this.searchAddressSelected.coordinates.lng.toString()
                    const selectedRadio = this.selectedRadioButtonData
                    if (selectedRadio.radioValue === "OikeusPuhelinJaLaajakaistaLiittymaanPalvelutyypinMukaan") {
                        this.oikeusPuhelinJaLaajakaistaLiittymaanSijainti = true
                    }
                    await this.setDataToLoad(selectedRadio)
                }
            }
        }

        get coordinates(): LatLngPoint | null {
            return store.getters.coordinates
        }

        @Watch("coordinates")
        async onCoordinatesChanged(): Promise<void> {
            if (this.coordinates) {
                if (this.selectedRadioButtonData.groupName === "OikeusPuhelinJaLaajakaistaLiittymaan") {
                    this.coordX = this.coordinates.lat.toString()
                    this.coordY = this.coordinates.lng.toString()
                    this.oikeusPuhelinJaLaajakaistaLiittymaanSijainti = true
                    const selectedRadio = this.selectedRadioButtonData
                    await this.setDataToLoad(selectedRadio)
                }
            }
        }

        async setDataToLoad(selectedRadio: RadioButtonModel): Promise<void> {
            if (selectedRadio !== this.selectedRadioButtonData) {
                return
            }

            if (this.currentPage !== this.pageName) {
                return
            }

            store.dispatch("setLoading", { name: this.pageName, value: true })

            this.selectedRadioButtonData = selectedRadio

            this.updateData(selectedRadio.radioValue, selectedRadio.selectedDropDownListValue, selectedRadio.dropDownListItems, selectedRadio)
        }

        async updateData(radioValue: string, selectedDropDownListValue: any, dropDownListItems: any, radio: RadioButtonModel | null): Promise<void> {
            if (radioValue !== "") {
                store.dispatch("setLoading", { name: this.pageName, value: true })

                store.dispatch("setLoading", { name: "laajakaistajapuhelin", value: true })
                // Asetetaan oikean slotin sisältö
                store.dispatch("setRightSlot", this.selectedRadioButtonData.groupName ?? this.selectedRadioButtonData.radioValue)

                const clearLocationMarker = !(store.getters.dataUrlToLoad?.url?.split("/")[2]?.toLowerCase() === "laajakaistajapuhelin" || store.getters.dataUrlToLoad?.url?.split("/")[2]?.toLowerCase().startsWith("infokartta"))

                if (radioValue === "KiinteanLaajakaistanSaatavuus") {
                    const selectedAreaRadioButton = store.getters.selectedAreaRadioButton
                    if (selectedAreaRadioButton === "kunta") {
                        store.dispatch("setDataUrlToLoad", { url: this.apiCallBasePart + "KiinteanLaajakaistanSaatavuusKuntaKohtainen", type: radioValue, clearLocationMarker })
                    }
                    else if (selectedAreaRadioButton === "maakunta") {
                        store.dispatch("setDataUrlToLoad", { url: this.apiCallBasePart + "KiinteanLaajakaistanSaatavuusMaakuntaKohtainen", type: radioValue, clearLocationMarker })
                    }
                    else {
                        store.dispatch("setDataUrlToLoad", { url: this.apiCallBasePart + "KiinteanLaajakaistanSaatavuusKokoSuomi", type: radioValue, clearLocationMarker })
                    }
                }
                else if (radioValue === "MobiiliverkonKattavuus") {
                    const selectedAreaRadioButton = store.getters.selectedAreaRadioButton
                    const filters = this.getFilters(this.selectedRadioButtonData)
                    if (selectedAreaRadioButton === "kunta") {
                        store.dispatch("setDataUrlToLoad", { url: this.apiCallBasePart + "MobiiliverkonKattavuusKuntakohtainen", type: radioValue, params: filters, clearLocationMarker })
                    }
                    else if (selectedAreaRadioButton === "maakunta") {
                        store.dispatch("setDataUrlToLoad", { url: this.apiCallBasePart + "MobiiliverkonKattavuusMaakuntakohtainen", type: radioValue, params: filters, clearLocationMarker })
                    }
                    else {
                        store.dispatch("setDataUrlToLoad", { url: this.apiCallBasePart + "MobiiliverkonKattavuusKokoSuomi", type: radioValue, params: filters, clearLocationMarker })
                    }
                }
                else if (radioValue === "KiinteanVerkonSaatavuusRuuduilla") {
                    store.dispatch("setDataUrlToLoad", { url: this.apiCallBasePart + "KiinteanVerkonSaatavuusRuudut", type: radioValue, clearLocationMarker })
                }
                else if (radio?.groupName !== null && radio?.groupName === "Infokartat") {
                    const infokartatApiCallBasePart: string = "v1/Infokartta/"
                    store.dispatch("setDataUrlToLoad", { url: infokartatApiCallBasePart + "Infokartta" + "?tunniste=" + radio.radioValue, type: "Infokartta", clearLocationMarker })
                }
                else if (radio?.groupName === "OikeusPuhelinJaLaajakaistaLiittymaan") {
                    const filters = this.getFilters(this.selectedRadioButtonData)
                    if (this.oikeusPuhelinJaLaajakaistaLiittymaanSijainti && filters.get("koordinaattiX") && filters.get("koordinaattiY")) {
                        store.dispatch("setDataUrlToLoad", { url: this.apiCallBasePart + "OikeusPuhelinJaLaajakaistaLiittymaanSijainninMukaan", type: "OikeusPuhelinJaLaajakaistaLiittymaanSijainninMukaan", params: filters, clearLocationMarker })
                    }
                    else if (!this.oikeusPuhelinJaLaajakaistaLiittymaanSijainti) {
                        store.dispatch("setDataUrlToLoad", { url: this.apiCallBasePart + "OikeusPuhelinJaLaajakaistaLiittymaanPalvelutyypinMukaan", type: radioValue, params: filters, clearLocationMarker })
                    }
                }
                else if (radioValue === "Laajakaistahankkeet") {
                    store.dispatch("setDataUrlToLoad", { url: this.apiCallBasePart + radioValue, type: radioValue, clearLocationMarker })
                }
            }
            store.dispatch("setLoading", { name: "laajakaistajapuhelin", value: false })
        }
    }

</script>

<style scoped>
    .subject-radios {
        margin-bottom: 20px;
    }

    .locate-me-wrapper {
        margin-bottom: 20px;
    }
</style>
